import React from 'react'
import { Button, Col, Image } from 'react-bootstrap'
import CountUp from 'react-countup'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import Card from '../common/Card'
import { ChevronLeftIcon } from '@/components/icons/new'
import { logos } from '../../utils/platform-logos'
import 'swiper/css'
import 'swiper/css/navigation'

const AudienceCounter = ({ platforms, data }) => {
    const duration = 3
    const start = 0

    // Safety check for platforms and data
    // if (!platforms || !Array.isArray(platforms) || !data || typeof data !== 'object') {
    //     return null
    // }

    return (
        <Col lg={12} md={12}>
            <div className="overflow-hidden d-slider1 tw:relative">
                <Swiper
                    as="ul"
                    className="p-0 m-0 swiper-wrapper list-inline"
                    slidesPerView={5}
                    spaceBetween={20}
                    modules={[Navigation]}
                    navigation={{
                        nextEl: '.audience-swiper-next',
                        prevEl: '.audience-swiper-prev',
                    }}
                    breakpoints={{
                        320: { slidesPerView: 1 },
                        550: { slidesPerView: 2 },
                        991: { slidesPerView: 3 },
                        1200: { slidesPerView: 4 },
                        1500: { slidesPerView: 5 },
                        1920: { slidesPerView: 6 },
                        2040: { slidesPerView: 7 },
                        2440: { slidesPerView: 8 },
                    }}
                    data-aos="fade-up"
                    data-aos-delay="700"
                >
                    {platforms.map((platform, index) => {
                        const platformData = data && data[platform.name]
                        const audienceValue =
                            platformData && typeof platformData.audience === 'number' ? platformData.audience : 0

                        return (
                            <SwiperSlide className="card card-slide tw:!rounded-xs" key={index}>
                                <Card.Body className={index === 0 ? 'dashboard-step-1 p-3' : 'p-3'}>
                                    <div className="progress-widget">
                                        <Button variant="sm social-btn rounded-circle p-2 no-pointer">
                                            <Image
                                                src={logos[platform.name]}
                                                alt={platform.name}
                                                className="img-fluid avatar-30 object-contain"
                                            />
                                        </Button>
                                        <div className="progress-detail">
                                            <p className="mb-1 tw:text-sm">{platform.name}</p>
                                            <p className="counter mb-0">
                                                <CountUp
                                                    start={start}
                                                    end={audienceValue}
                                                    duration={duration}
                                                    redraw={false}
                                                />
                                            </p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </SwiperSlide>
                        )
                    })}
                </Swiper>
                <button
                    type="button"
                    className="audience-swiper-next tw:absolute tw:right-0 tw:top-[38%] tw:z-10 tw:inline-flex tw:h-6 tw:w-6 tw:-translate-y-1/2 tw:items-center tw:justify-center tw:rounded-full tw:border tw:border-transparent tw:bg-transparent tw:text-gray-200 hover:tw:cursor-pointer"
                    aria-label="Next slide"
                >
                    <ChevronLeftIcon size={24} color="currentColor" aria-hidden="true" />
                </button>
                <button
                    type="button"
                    className="audience-swiper-prev tw:absolute tw:left-0 tw:top-[38%] tw:z-10 tw:inline-flex tw:h-6 tw:w-6 tw:-translate-y-1/2 tw:items-center tw:justify-center tw:rounded-full tw:border tw:border-transparent tw:bg-transparent tw:text-gray-200 hover:tw:cursor-pointer"
                    aria-label="Previous slide"
                >
                    <ChevronLeftIcon
                        size={24}
                        color="currentColor"
                        aria-hidden="true"
                        style={{ transform: 'rotate(180deg)' }}
                    />
                </button>
            </div>
        </Col>
    )
}

export default AudienceCounter
